export default __webpack_public_path__ + "static/media/ALLERGEN_TREE_NUTS.715f3424.png";